import enUsTranslation from './en-us';
import ptBrTranslation from './pt-br';

const localization = {
  'pt-BR': ptBrTranslation,
  'en-US': enUsTranslation
};

export default localization;
